import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Button,
  Alert,
  CardTitle,
  FormGroup,
  Input
} from "reactstrap";
import axios from "axios";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { useNavigation, useCurrentRoute, Link } from "react-navi";
import Container from "../components/Container";
import { downloadFile } from "../../services/utils";
import configService from "../../services/api/configService";

export function Configs() {
  const [data, setData] = useState(null);

  const route = useCurrentRoute();
  const navigation = useNavigation();

  useEffect(() => {
    setData(route.data.configs);
  }, [route.data.configs]);

  function handleDownload(event) {
    event.persist();
    event.preventDefault();
    axios({
      url:
        process.env.REACT_APP_API_URL +
        "resource/config/".concat(event.target.value),
      method: "GET",
      responseType: "blob" // important
    }).then(response => {
      // We trigger a download by creating a "a" tag with the url of the config and programmatically clicking on it
      const fileName = `${event.target.name  }.pdf`;
      downloadFile(response.data, fileName);
    });
  }

  async function handleDelete(event) {
    const confirm = window.confirm(
      "Are you sure you want to delete this configuration?"
    );
    if (!confirm) return;
    const eventId = event.target.value;

    const success = await configService.deleteConfig(eventId);

    if (success) {
      const newConfigs = data.filter(config => config.eventId !== eventId);
      setData(newConfigs);
    }
  }

  function handleGet(event) {
    navigation.navigate(
      `/machines/${  route.data.machineid  }/configs/${  event.target.value}`
    );
  }

  async function activateConfig(event) {
    await axios
      .post(
        process.env.REACT_APP_API_URL.concat(event.target.value, "/activate")
      )
      .then(response => {
        if (response.status === 200) {
          axios
            .get(process.env.REACT_APP_API_URL.concat(route.data.machineid))
            .then(response => {
              setData(response.data);
            });
        }
      });
  }

  const columns = [
    {
      Header: "Event ID",
      accessor: "eventId"
    },
    {
      Header: "Event name",
      accessor: "eventName"
    },
    {
      Header: "Setting",
      accessor: "setting"
    },
    {
      Header: "Actions",
      accessor: "eventId",
      minWidth: 400,
      maxWidth: 400,
      Cell: d => (
        <div className="d-flex justify-content-center">
          <Button
            outline
            className="btn-black ml-2 mr-3 col-md-3"
            color="dark"
            value={d.value}
            onClick={handleGet}
          >
            Details
          </Button>
          <a
            className="btn-black ml-2 mr-3 btn btn-outline-dark col-md-4"
            href={
              process.env.REACT_APP_API_URL + "resource/config/".concat(d.value)
            }
          >
            Download
          </a>
          <Button
            outline
            className="col-md-3 btn-red"
            color="danger"
            value={d.value}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </div>
      )
    },
    {
      Header: "Active",
      accessor: "eventId",
      Cell: d => (
        <FormGroup className="d-flex justify-content-center" check>
          {" "}
          <Input
            name="active"
            type="radio"
            className="ml-auto"
            value={d.value}
            checked={d.original.active}
            onClick={activateConfig}
          />
        </FormGroup>
      )
    }
  ];

  return (
    <Container title={`Machine ${  route.data.machineid}`}>
      <Link
        href={`/machines/${  route.data.machineid  }/configs/create`}
        className="btn btn-black btn-block btn-outline-dark"
      >
        Create configuration
      </Link>
      <hr className="hr-black" />
      {data ? (
        <ReactTable
          columns={columns}
          data={data}
          className="-striped -highlight"
        />
      ) : null}
    </Container>
  );
}

export default Configs;



// WEBPACK FOOTER //
// ./src/views/Configuration/configs.jsx